var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
var Root = styled('div', {
    name: 'QuantumRowLayout',
    slot: 'Root',
})({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
});
export var RowLayout = React.forwardRef(function (_a, ref) {
    var component = _a.component, asProp = _a.as, _b = _a.gutter, gutter = _b === void 0 ? 3 : _b, children = _a.children, _c = _a.sx, sx = _c === void 0 ? {} : _c, rootProps = __rest(_a, ["component", "as", "gutter", "children", "sx"]);
    return (React.createElement(Root, __assign({ as: asProp || component || 'div', ref: ref, sx: __assign(__assign({}, sx), { gap: gutter }) }, rootProps), children));
});
